import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
function SvgCheckmark(props) {
    return (_jsx("svg", Object.assign({ viewBox: "0 0 20 20" }, props, { children: _jsx("path", { d: "M0 11l2-2 5 5L18 3l2 2L7 18z" }) })));
}
export default SvgCheckmark;
